import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { getKeycloakLoginUrl, getDriverAppUrl } from '../auth';
import useBrand from '../branding/useBrand';
import './TopMenu.css';

function TopMenu() {
  const brand = useBrand();
  const { pathname } = useLocation();
  const isContactPage = pathname === '/contact';
  const primaryLinks = [
    { to: '/product', label: brand.nav.product },
    { to: '/how-it-works', label: brand.nav.howItWorks },
    { to: '/technology', label: brand.nav.technology },
    { to: '/contact', label: brand.nav.contact },
  ];
  const handleLoginAsCPO = () => { window.location.href = getKeycloakLoginUrl(); };

  return (
    <nav className="top-menu navbar navbar-expand-md navbar-dark">
      <div className="container-fluid">
        <NavLink to="/" className="top-menu-brand navbar-brand" aria-label={`${brand.name} home`}>
          <span className="top-menu-brand-mark" aria-hidden="true">{brand.mark}</span>
          <span className="top-menu-brand-copy">
            <span className="top-menu-brand-title">{brand.shortName}</span>
            <span className="top-menu-brand-subtitle">{brand.tagline}</span>
          </span>
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#topMenuNav"
          aria-controls="topMenuNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="topMenuNav">
          <ul className="navbar-nav me-auto mb-2 mb-md-0">
            {primaryLinks.map(({ to, label }) => (
              <li key={to} className="nav-item">
                <NavLink to={to} className="nav-link">{label}</NavLink>
              </li>
            ))}
          </ul>
          <div className="top-menu-cta">
            {!isContactPage && (
              <Link to="/contact" className="btn btn-outline-light btn-sm top-menu-demo">
                {brand.nav.requestDemo}
              </Link>
            )}
            <button
              type="button"
              className="btn btn-primary btn-sm top-menu-login"
              onClick={handleLoginAsCPO}
            >
              {brand.nav.login}
            </button>
            <a href={getDriverAppUrl()} className="top-menu-driver-link">
              {brand.nav.driverApp} &rarr;
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default TopMenu;
